import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireComponentQuotation} from '@tisa-group/models';

@Component({
  selector: 'tisa-quote',
  imports: [CommonModule],
  templateUrl: './quote.component.html',
  styleUrl: './quote.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteComponent {
  readonly component = input<UmpireComponentQuotation | undefined>();
}
